import { Button } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useCalendarsStore, useThemeStore } from "../../stores/index.js";
import { resolvedCalendarColor } from "../entity-colors.js";

/** Single-select calendar picker. A task belongs to exactly one calendar; the
 *  chosen one is highlighted. Lives under the form's Advanced options. */
export function CalendarField({ value, onChange }: { value: string | null; onChange: (id: string) => void }) {
  const { t } = useI18n();
  const calendars = useCalendarsStore((s) => s.calendars);
  const theme = useThemeStore((s) => s.config);
  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs text-muted-foreground">{t("common.calendar")}</p>
      <div className="flex flex-wrap items-center gap-1.5">
        {calendars.map((c) => {
          const color = resolvedCalendarColor(theme, calendars, c.id);
          return (
            <Button
              key={c.id}
              type="button"
              size="sm"
              variant={value === c.id ? "primary" : "outline"}
              onClick={() => onChange(c.id)}
              className="gap-1.5"
            >
              <span
                className="h-2.5 w-2.5 rounded-full border"
                style={{ background: color ?? "transparent" }}
              />
              {c.name}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
